import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { useRequestMediaPermissionsCallback } from '../utils/media';
import { ExclamationMarkIcon } from './Icon';
export function DeviceBlockedPlate({ kind }) {
    const deviceType = kind === 'audio' ? 'microphone' : 'camera';
    const requestMediaPermission = useRequestMediaPermissionsCallback();
    return (_jsxs(DeviceBlockedPlateRoot, { children: [_jsxs(Content, { children: [_jsx(ExclamationMarkIcon, {}), _jsxs("div", { children: ["Your ", deviceType, " is blocked"] })] }), _jsxs(AllowButton, { type: "button", onClick: () => {
                    requestMediaPermission({
                        audio: kind === 'audio',
                        video: kind === 'video',
                    });
                }, children: ["Allow ", deviceType] })] }));
}
const AllowButton = styled.button `
    appearance: none;
    border: 0;
    background: rgba(53, 54, 49, 0.55);
    border-radius: 0.75rem;
    color: #ffffff;
    font-size: 1rem;
    line-height: 1.2;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.5rem;
    font-weight: 500;
    transition: 200ms transform;

    &:hover {
        transform: scale(1.05);
    }
`;
const Content = styled.div `
    align-items: center;
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    width: 100%;
    margin-bottom: 1rem;
    font-weight: 500;
    color: #323232;
`;
const DeviceBlockedPlateRoot = styled.div `
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid rgba(222, 222, 222, 0.2);
    box-shadow: 0px 0.75rem 1.5rem rgba(0, 0, 0, 0.3),
        inset 0px 0px 0.125rem rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    padding: 1.5rem;
    border-radius: var(--DeviceBlockedPlate_BorderRadius, 1rem);
    line-height: 1;
`;
